// extracted by mini-css-extract-plugin
module.exports = {"chevron":"style_chevron__7MCk2","spin":"style_spin__dZ8uc"};